module.exports = __webpack_public_path__ + "6c80563ab4d1d693ddd0912ca5445d19.MP3";